export function unpackMaybe<T>(value: T): NonNullable<T> | undefined;
export function unpackMaybe<T, F>(value: T, fallback: F): NonNullable<T> | F;
export function unpackMaybe<T, F>(value: T, fallback?: F) {
  return ((value ?? undefined) as NonNullable<T>) || fallback;
}
